module.exports = __webpack_public_path__ + "img/tk.be6701be.svg";